document
	.addEventListener(
		"DOMContentLoaded",
		() => {

			initNavBarHeaderOffset();

			const links = document.querySelectorAll('.cirrus-nav-bar a');
			const list = document.querySelector('.cirrus-nav-bar > div');

			if (links.length > 0) {

				const observer = new IntersectionObserver(
					(entries) => {
						entries.forEach(
							(entry) => {
								const id = entry.target.getAttribute('id');
								const link = document.querySelector(`.cirrus-nav-bar a[href="#${id}"]`);
								if (link) {
									if (entry.isIntersecting) {
										link.classList.add('active');
										window.gsap.to(
											list,
											{
												duration: 0.5,
												scrollTo: { x: link, offsetX: 10 }
											}
										);
									} else {
										link.classList.remove('active');
									}
								}
							}
						);
					},
					{
						rootMargin: '0px 0px -100% 0px',
						threshold: 0,
					}
				);

				links.forEach(
					(link) => {
						const href = link.getAttribute('href');
						const id = href.replace('#', '');
						const target = document.getElementById(id);
						if (target) {
							link.addEventListener('click', (e) => {
								e.preventDefault();
								observer.unobserve(target);
								window.scroll({
									top: target.getBoundingClientRect().top + window.scrollY + 1,
									behavior: 'smooth'
								});
								setTimeout(unpinHeader, 1000);
								observer.observe(target);
							});
							observer.observe(target);
						}
					}
				);

			}

			function unpinHeader() {
				const header = document.querySelector('.headroom');
				if (!header) {
					return;
				}
				header.classList.remove('headroom--pinned');
				header.classList.add('headroom--unpinned');
			}

		}
	);

/**
 * Keep TRAC nav below the visible site header when stuck (MDS-599).
 * Replaces the theme translateY(68px) hack with a dynamic, instant top offset.
 * Syncs on header pin/unpin and scroll end — not on every scroll frame.
 */
function initNavBarHeaderOffset() {
	const nav = document.querySelector('.cirrus-nav-bar');
	if (!nav) {
		return;
	}

	const headerSelector = '.site-header.headroom, .site-header--new';
	const HEADER_TRANSITION_MS = 320;
	let stickAt = nav.getBoundingClientRect().top + window.scrollY;
	let debounceTimer = null;
	let afterPinTimer = null;

	const getHeader = () => document.querySelector(headerSelector);

	const isHeaderHidden = (header) => (
		header?.classList.contains('headroom--unpinned')
		|| header?.classList.contains('site-header--new--unpinned')
	);

	const getAdminBarOffset = () => {
		const adminBar = document.getElementById('wpadminbar');
		if (!adminBar) {
			return 0;
		}
		return Math.max(0, Math.round(adminBar.getBoundingClientRect().bottom));
	};

	const isStuck = () => window.scrollY >= stickAt - 1;

	const measureStickAt = () => {
		if (!isStuck()) {
			stickAt = nav.getBoundingClientRect().top + window.scrollY;
		}
	};

	const syncNavOffset = () => {
		if (!isStuck()) {
			nav.style.removeProperty('top');
			return;
		}

		const header = getHeader();
		let offset = 0;

		if (header && !isHeaderHidden(header)) {
			offset = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
		} else {
			offset = getAdminBarOffset();
		}

		const nextTop = `${offset}px`;
		if (nav.style.top !== nextTop) {
			nav.style.top = nextTop;
		}
	};

	const scheduleSync = () => {
		syncNavOffset();
		window.clearTimeout(afterPinTimer);
		afterPinTimer = window.setTimeout(syncNavOffset, HEADER_TRANSITION_MS);
	};

	const onResize = () => {
		measureStickAt();
		syncNavOffset();
	};

	const onScrollSettled = () => {
		measureStickAt();
		syncNavOffset();
	};

	const onScrollDebounced = () => {
		window.clearTimeout(debounceTimer);
		debounceTimer = window.setTimeout(onScrollSettled, 150);
	};

	window.addEventListener('resize', onResize, { passive: true });

	if ('onscrollend' in window) {
		window.addEventListener('scrollend', onScrollSettled, { passive: true });
	} else {
		window.addEventListener('scroll', onScrollDebounced, { passive: true });
	}

	const header = getHeader();
	if (header) {
		const headerObserver = new MutationObserver(scheduleSync);
		headerObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
	}

	const bodyObserver = new MutationObserver(scheduleSync);
	bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class'] });

	scheduleSync();
}
